var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCalendarFilled = function SvgCalendarFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 20,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#calendarFilled_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#calendarFilled_svg__b)",
    d: "m14.742 4.183-.425-.025v-1.1a.747.747 0 0 0-.75-.75.747.747 0 0 0-.75.75v1A51 51 0 0 0 10.55 4c-.808 0-1.617.025-2.425.066V3.058a.747.747 0 0 0-.75-.75.747.747 0 0 0-.75.75v1.108c-.092 0-.175.009-.267.017-1.466.142-2.908 1.492-3.191 2.95h14.766c-.283-1.458-1.725-2.808-3.191-2.95"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "calendarFilled_svg__e",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M3.042 8.383h15a34.6 34.6 0 0 1-.075 5.8c-.167 1.542-1.692 3.017-3.234 3.167a50.4 50.4 0 0 1-8.383 0c-1.533-.15-3.067-1.625-3.233-3.167a34.6 34.6 0 0 1-.075-5.8m3.183 4.825q.94.051 1.892 0a.94.94 0 0 0 .85-.85c.033-.625.033-1.258 0-1.891a.94.94 0 0 0-.85-.85 18 18 0 0 0-1.892 0 .94.94 0 0 0-.85.85 18 18 0 0 0 0 1.891.94.94 0 0 0 .85.85",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#calendarFilled_svg__c)",
    fillRule: "evenodd",
    d: "M3.042 8.383h15a34.6 34.6 0 0 1-.075 5.8c-.167 1.542-1.692 3.017-3.234 3.167a50.4 50.4 0 0 1-8.383 0c-1.533-.15-3.067-1.625-3.233-3.167a34.6 34.6 0 0 1-.075-5.8m3.183 4.825q.94.051 1.892 0a.94.94 0 0 0 .85-.85c.033-.625.033-1.258 0-1.891a.94.94 0 0 0-.85-.85 18 18 0 0 0-1.892 0 .94.94 0 0 0-.85.85 18 18 0 0 0 0 1.891.94.94 0 0 0 .85.85",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#calendarFilled_svg__d)",
    d: "m18.042 8.383 1.596-.11-.103-1.49h-1.493zm-15 0v-1.6H1.548l-.103 1.49zm14.925 5.8 1.59.172.001-.007v-.007zm-3.234 3.167.133 1.594h.011l.011-.002zm-8.383 0-.156 1.592.012.002h.011zm-3.233-3.167-1.593.158.001.007v.007zm5-.975.084 1.598h.008zm-1.892 0-.092 1.598h.007zm2.742-.85 1.597.092v-.006zm0-1.891 1.598-.085-.001-.008zm-.85-.85.092-1.598h-.007zm-1.892 0-.084-1.598h-.008zm-.85.85-1.597-.093v.007zm0 1.891-1.598.084v.008zm12.667-5.575h-15v3.2h15zm1.517 7.558c.201-2.029.218-4.052.079-6.068l-3.193.22c.128 1.851.112 3.695-.07 5.532zm-4.67 4.601c1.204-.117 2.296-.73 3.094-1.508.798-.779 1.442-1.86 1.574-3.079l-3.181-.344c-.035.323-.236.75-.628 1.132-.391.382-.833.582-1.17.614zm-4.347.183c1.444 0 2.88-.06 4.324-.18l-.266-3.19a49 49 0 0 1-4.058.17zm-4.325-.18c1.444.12 2.88.18 4.325.18v-3.2c-1.356 0-2.703-.057-4.06-.17zm-4.691-4.59c.132 1.222.78 2.303 1.579 3.08.797.777 1.888 1.39 3.09 1.507l.31-3.184c-.331-.033-.774-.232-1.168-.616-.394-.383-.595-.81-.63-1.13zm-.08-6.082a36 36 0 0 0 .078 6.068l3.185-.316a33 33 0 0 1-.071-5.532zm6.587 3.338q-.869.045-1.723 0l-.17 3.195c.682.036 1.372.036 2.06 0zm-.664.655a.7.7 0 0 1 .194-.461c.08-.08.23-.18.461-.194l.185 3.195c1.244-.072 2.283-1.111 2.355-2.356zm0-1.715c.03.577.03 1.154 0 1.722l3.195.17a20 20 0 0 0 0-2.06zm.655.663a.7.7 0 0 1-.46-.194.7.7 0 0 1-.195-.461l3.195-.184c-.072-1.245-1.11-2.284-2.355-2.356zm-1.715 0c.578-.03 1.155-.03 1.722 0l.17-3.195a20 20 0 0 0-2.06 0zm.663-.655a.7.7 0 0 1-.194.46c-.08.08-.23.182-.46.195l-.185-3.195c-1.245.072-2.284 1.111-2.355 2.355zm0 1.715c-.03-.577-.03-1.154 0-1.722l-3.195-.17a20 20 0 0 0 0 2.06zm-.655-.663a.7.7 0 0 1 .461.194c.08.08.181.23.194.461l-3.194.184c.071 1.245 1.11 2.284 2.355 2.356z",
    mask: "url(#calendarFilled_svg__e)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "calendarFilled_svg__b",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(137.078 6.155 3.668)scale(7.72509 32.7491)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE7B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2B518"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "calendarFilled_svg__c",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(120.25 4.284 7.851)scale(11.5385 42.6862)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE7B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F2B518"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "calendarFilled_svg__d",
    x1: 10.542,
    x2: 10.542,
    y1: 8.383,
    y2: 17.525,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE08F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F9BB1D"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "calendarFilled_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.5 0h20v20H.5z"
  })))));
};
export default SvgCalendarFilled;